<template>
  <v-form v-model="valid" ref="mainForm">
    <!-- 1. Infolettre -->
    <ressource code="description-infolettre"></ressource>
    <opq-catalogue
      code="consentement-infolettre"
      v-model="sasConsentement.recevoirLInfolettreDeLOrdreDesPsychologues"
      :live="liveSasConsentement(4103)"
    ></opq-catalogue>

    <!-- 2. Magazine psychologie Québec -->
    <ressource code="description-magazine-psychologie-quebec"></ressource>
    <opq-catalogue
      code="consentement-magazine-psychologie-quebec"
      v-model="sasConsentement.magazinePsychologieQuebec"
      :live="liveSasConsentement(4111)"
    ></opq-catalogue>

    <!-- 3. Annonces de tier (formation continue) -->
    <!-- 4. Annonces de tier (autres) -->
    <ressource code="description-annonces-tiers"></ressource>
    <opq-catalogue
      code="consentement-annonce-formation"
      v-model="sasConsentement.offresDeFormationContinue"
      :live="liveSasConsentement(4106)"
    ></opq-catalogue>
    <opq-catalogue
      code="consentement-annonce-autre"
      v-model="sasConsentement.annoncesDAutresProduitsEtServices"
      :live="liveSasConsentement(4107)"
    ></opq-catalogue>

    <!-- 5. Informations accessible au public -->
    <ressource code="description-accessible-public"></ressource>
    <opq-catalogue
      code="consentement-accessible-public"
      v-model="sasConsentement.informationsAccessiblesAuPublicSurDemande"
      :live="liveSasConsentement(4108)"
      :disabled="accessiblePublicAllCheckedAndDisabled"
      ref="informationsAccessiblesAuPublicSurDemande"
      optional
      :code-exclude="sas.informationsPublicInaccessibles"
    ></opq-catalogue>

    <!-- 6. Répertoire -->
    <opq-catalogue
      code="consentement-repertoire"
      v-model="sasConsentement.apparitionInformationsDansLeRepertoire"
      :live="liveSasConsentement(4102)"
    ></opq-catalogue>

    <!-- 7. Plateforme de formation continue (Illuxi) -->
    <ressource code="description-illuxi"></ressource>
    <opq-catalogue
      code="consentement-illuxi"
      v-model="sasConsentement.consentementIlluxi"
      :live="liveSasConsentement(4113)"
    ></opq-catalogue>

    <!-- 8. Transmission de listes aux tiers payants -->
    <ressource code="description-transmission-tiers"></ressource>
    <opq-catalogue
      code="consentement-transmission-tiers"
      v-model="sasConsentement.apparitionNom"
      :live="liveSasConsentement(4109)"
    ></opq-catalogue>

    <!-- 9. Institut canadien d'information sur la santé (ICIS) -->
    <ressource code="description-icis"></ressource>
    <opq-catalogue
      code="consentement-icis"
      v-model="sasConsentement.consentementIcis"
      :live="liveSasConsentement(4112)"
    ></opq-catalogue>
  </v-form>
</template>

<script>
import CataloguesHelper from "@/mixins/CataloguesHelpers"
import FormSimple from "@/mixins/FormSimple"
export default {
  mixins: [CataloguesHelper, FormSimple],
  props: {
    sas: { type: Object },
  },

  methods: {
    liveSasConsentement(cle) {
      return { endpoint: "sas-consentements", cle: cle, fileId: this.sasConsentement.id }
    },
  },

  computed: {
    sasConsentement() {
      return this.sas.sasConsentement
    },
    sasServiceDeReference() {
      return this.sas.sasServiceDeReference
    },
    accessiblePublicAllCheckedAndDisabled() {
      return this.estOui(this.sasServiceDeReference.desireSinscrire)
    },
  },
  watch: {
    accessiblePublicAllCheckedAndDisabled(newValue) {
      if (newValue) {
        this.$refs.informationsAccessiblesAuPublicSurDemande.checkAll()
      }
    },
  },
}
</script>

<style></style>
